// extracted by mini-css-extract-plugin
module.exports = {"container":"part-exchange-menu_container__v9PDD","faqList":"part-exchange-menu_faqList__ubtPj"};